import "./ArchiveProductTemplate.module.css"
import MainNavigation from "@/reusable_sections/Header"
import ArchiveTitleSectionSection from "./sections/ArchiveTitleSectionSection"
import ShopContent from "./sections/ShopContent"
import SariHutFooter from "@/reusable_sections/Footer"

export default function ArchiveProductTemplatePage() {

  return (
    <div>
      <MainNavigation />
      <ArchiveTitleSectionSection />
      <ShopContent />
      <SariHutFooter />
    </div>
  )
}
